import {
  type AltchaWidgetElement,
  makeAltchaBoxClickable,
  setupAltcha,
  waitForAltcha,
} from "../utils/altcha";

setupAltcha();

export const initContact = () => {
  const contactForm = document.getElementById("contact-form") as HTMLFormElement;

  if (!contactForm) {
    return;
  }

  const addMoreFilesBtn = contactForm.querySelector(".add-more-files") as HTMLButtonElement;
  const attachmentsWrapper = contactForm.querySelector(".attachments-wrapper");
  const firstAttachmentWrapper = contactForm.querySelector(
    ".attachment-item-wrapper",
  ) as HTMLDivElement;

  addMoreFilesBtn.addEventListener("click", () => {
    const attachmentsItemsCount = contactForm.querySelectorAll(".attachment-item-wrapper").length;
    const newAttachmentItem = firstAttachmentWrapper.cloneNode(true) as HTMLDivElement;
    const nextAttachmentNum = attachmentsItemsCount + 1;

    if (nextAttachmentNum >= 2) {
      addMoreFilesBtn.classList.add("d-none");
    }

    const newIdentifier = `contactFormFile${nextAttachmentNum}`;

    if (newAttachmentItem && attachmentsWrapper) {
      const input = newAttachmentItem.querySelector("input") as HTMLInputElement;

      input.value = "";
      input.id = newIdentifier;

      attachmentsWrapper.append(newAttachmentItem);
    }
  });

  // Altcha handling
  const altchaWrapper = contactForm.querySelector(".altcha-wrapper") as HTMLDivElement;
  const altchaWidget = contactForm.querySelector(
    ".altcha-wrapper altcha-widget",
  ) as AltchaWidgetElement;
  const submitButton = contactForm.querySelector(".contact-submit") as HTMLButtonElement;

  if (altchaWrapper && altchaWidget && submitButton) {
    makeAltchaBoxClickable(altchaWidget);

    submitButton.addEventListener("click", (e) => {
      e.preventDefault();
      submitButton.disabled = true;

      waitForAltcha(altchaWrapper, altchaWidget)
        .then((payload) => {
          if (!contactForm.checkValidity()) {
            contactForm.reportValidity();
            submitButton.disabled = false;
            return;
          }

          const altchaInput = contactForm.querySelector('input[name="altcha"]') as HTMLInputElement;
          if (altchaInput) {
            altchaInput.value = payload;
          }
          contactForm.submit();
        })
        .catch(() => {
          submitButton.disabled = false;
        });
    });
  }
};
